import React from "react"
import { ETrendTimeScope, ETrendUnitType, IGroupedTrend, ITrendSearch } from "../../../models/data/dashboard/Trends/TrendsData"
import Table from "../../../components/common/Table"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, FontIcon, } from "material-ui"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import TrendChangeChip from "./TrendChangeChip"
import TrendSummaryTrendLine from "./TrendSummaryTrendLine"
import * as setGlobalHierarchyLevel from "../../../helpers/setGlobalHierarchyLevel"

export interface IProps {
    trendSearch: ITrendSearch
    selectedItem: IGroupedTrend
    scope: ETrendTimeScope
    leafNodes: boolean
}

export default class TrendHierarchyChildrenTable extends React.Component<IProps, any> {    
    componentDidMount() {
    }

    componentDidUpdate() {
    }

    getChildItems(): IGroupedTrend[] {
        let returnVal = null;
    
        if (this.props.leafNodes) {
            returnVal = this.props.trendSearch.GroupedTrends
                .filter(item => item.LeafNode && item.Settings.Id === this.props.selectedItem.Settings.Id)
                .map(item => {
                    //I Am not sure why the leafnodes series data got inverted but it causes a bug in the trendline being opposite from what it should look like
                    if (item.LeafNode) {
                        // Inverse ChangedValue
                        if (item.Totals && item.Totals.ChangedValue !== undefined) {
                            item.Totals.ChangedValue = item.Totals.ChangedValue * -1;
                        }
                        // Reverse the SeriesData array for leaf nodes if needed
                        if (item.SeriesData && item.SeriesData.length > 1) {
                            item.SeriesData = item.SeriesData.slice().reverse();
                        }
                    }
                    return item;
                })
                .sort((a, b) => a.HierarchyName > b.HierarchyName ? 0 : 1);
        } else {
            returnVal = this.props.trendSearch.GroupedTrends
                .filter(item => item.HierarchyId !== this.props.selectedItem.HierarchyId
                    && item.ParentHierarchyId === this.props.selectedItem.HierarchyId
                    && !item.LeafNode
                    && item.Settings.Id === this.props.selectedItem.Settings.Id)
                .sort((a, b) => a.HierarchyName > b.HierarchyName ? 0 : 1);
        }
    
        console.log("getChildItems");
        console.log(returnVal);
    
        return returnVal;
    }
    
      render() {
        const data = this.getChildItems();
        let hierarchyDefinitionLabel = null;
        let showPeriodChange = this.props.selectedItem.SeriesData && this.props.selectedItem.SeriesData.length > 1;
    
        if (this.props.leafNodes) {
            hierarchyDefinitionLabel = this.props.selectedItem.Settings.ObjectName;
        } else {
            let hierarchyDefinition = data && data.length > 0 
                ? hierarchyHelper.getHierarchyDefinitionByHierarchyItemId(data[0].HierarchyId) 
                : null;
    
            if (!hierarchyDefinition && data && data.length > 0) {
                hierarchyDefinition = hierarchyHelper.getHierarchyDefinitionByHierarchyItemId(data[0].ParentHierarchyId);
            }
    
            hierarchyDefinitionLabel = hierarchyDefinition
                ? `${this.props.selectedItem.Settings.Name} - ${hierarchyDefinition.Label}` 
                : "";
        }
    
        if (!data || !data[0]) {
            return <div />;
        }
    
        // Check if SeriesData is defined and has at least one item
        const hasSeriesData = this.props.selectedItem.SeriesData && this.props.selectedItem.SeriesData.length > 0;

        return (
            <div style={{ padding: 20 }}>
                {data && 
                    <Table
                        items={data}
                        allowClickRow={true}
                        handleClickRow={(row) => {
                            if (!this.props.leafNodes) {
                                const hierarchyLevel = hierarchyHelper.getHierarchyItemById(row.HierarchyId);
                                setGlobalHierarchyLevel.setGlobalHierarchyLevel(hierarchyLevel);
                            }
                        }}
                        total={data.length}
                        readonly={this.props.leafNodes}
                        handleSelect={(row) => {
                            if (!this.props.leafNodes) {
                                const hierarchyLevel = hierarchyHelper.getHierarchyItemById(row[0].HierarchyId);
                                setGlobalHierarchyLevel.setGlobalHierarchyLevel(hierarchyLevel);
                            }
                        }}
                        singleSelectable={true}
                    >
                        <TableHeader>
                            <TableRow>
                                <TableHeaderColumn>{hierarchyDefinitionLabel}</TableHeaderColumn>
                                {this.props.leafNodes && <TableHeaderColumn>Hierarchy</TableHeaderColumn>}
                                {showPeriodChange && <TableHeaderColumn></TableHeaderColumn>}
                                {showPeriodChange && <TableHeaderColumn>Period Change</TableHeaderColumn>}
                                {hasSeriesData && this.props.selectedItem.Settings.AggregationSettings.AggregationType === 1 && 
                                    <TableHeaderColumn style={{
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '400px'
                                      }}
                                      title={`${this.props.selectedItem.Settings.AggregationSettings.NumeratorName}/${this.props.selectedItem.Settings.AggregationSettings.DenominatorName}`}>
                                        {this.props.selectedItem.Settings.AggregationSettings.NumeratorName}/{this.props.selectedItem.Settings.AggregationSettings.DenominatorName}
                                        </TableHeaderColumn>}
                                <TableHeaderColumn>Total {this.props.selectedItem.Settings.UnitName}</TableHeaderColumn>
                                {false && <TableHeaderColumn>{this.props.selectedItem.Settings.ObjectName}s Flagged</TableHeaderColumn>}
                            </TableRow>
                        </TableHeader>
                        <TableBody showRowHover={!this.props.leafNodes} deselectOnClickaway={false} selectable={!this.props.leafNodes}>
                            {data.map((row, i) =>
                                <TableRow key={`${row.Id}-${i}`} selected={false} hoverable={!row.LeafNode} selectable={!row.LeafNode}>
                                    <TableRowColumn>
                                        {(this.props.leafNodes ? row.ObjectName : row.HierarchyName)}
                                    </TableRowColumn>
                                    {this.props.leafNodes &&
                                        <TableRowColumn title={(row.ParentHierarchyId ? hierarchyHelper.getFullPathLabel(row.ParentHierarchyId) : null)}>
                                            {(hierarchyHelper.getHierarchyItemById(row.ParentHierarchyId) ? hierarchyHelper.getHierarchyItemById(row.ParentHierarchyId).Label : null)}
                                        </TableRowColumn>
                                    }                                    
                                    {showPeriodChange &&
                                        <TableRowColumn>
                                            <TrendSummaryTrendLine groupedTrend={row} scope={this.props.scope} value={(row.Totals && row.Totals.ChangedValue)} settings={this.props.selectedItem.Settings} />                        
                                        </TableRowColumn>
                                    }
                                    {showPeriodChange &&
                                        <TableRowColumn>
                                            <TrendChangeChip value={(row.Totals && row.Totals.ChangedValue)} settings={this.props.selectedItem.Settings} />
                                        </TableRowColumn>
                                    }
                                    {hasSeriesData && this.props.selectedItem.Settings.AggregationSettings.AggregationType === 1 && 
                                        <TableRowColumn>
                                        {row.SeriesData.reduce((sum, data) => sum + data.Numerator, 0)}/
                                        {row.SeriesData.reduce((sum, data) => sum + data.Denominator, 0)}
                                    </TableRowColumn>                                                                 
                                    }
                                    <TableRowColumn>
                                        {row.Totals && row.Totals.PeriodTotal}{this.props.selectedItem.Settings.UnitType === ETrendUnitType.Percentage && <span style={{}}>%</span>}
                                    </TableRowColumn>
                                    {false &&
                                    <TableRowColumn>
                                        0
                                    </TableRowColumn>                                                                                                            
                                    }
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>                
                }
            </div>
        );
    }
}